import React, { useState, useImperativeHandle, forwardRef, useRef } from 'react'
import Api from '../../../../../_helpers/Api'

//images
import loader from '../../../../../assets/images/app/loader.svg'
import closeIcon from '../../../../../assets/images/modals/icons/close.png'
import deleteIcon from '../../../../../assets/images/modals/icons/delete.png'

//modals
import SuccessModal from '../../../../modals/Success'
import RemoveModal from '../../../../modals/Remove'

function CreateEdit(props, ref) {
    //success modal message

    const worker = {
        name: '',
        icon: '',
    }

    const [createEdit, setCreateEdit] = useState({
        overlay: false,
        modal: false,
        types: [],
        clients: [],
        loading: false,
        //edit
        mainLoading: false,
        id: null,
        worker: worker,
        original: worker,
        icon: '',
    })

    const form = document.getElementById('edit-form')

    //refs
    const successModalRef = useRef(null)
    const removeModalRef = useRef(null)
    const uploadInputRef = useRef(null)
    //refs end

    useImperativeHandle(ref, () => ({
        open: id => handleOpen(id),
        close: () => handleClose(),
    }))

    const handleOpen = id => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            overlay: true,
            id: id,
            mainLoading: id ? true : false,
        }))
        setTimeout(() => {
            setCreateEdit(createEdit => ({
                ...createEdit,
                modal: true,
            }))
        }, 50)

        if (id) {
            Api.get(`types/find?id=${id}`)
                .then(res => {
                    setCreateEdit(createEdit => ({
                        ...createEdit,
                        worker: res.data,
                        original: res.data,
                    }))
                }).finally(() => stopMainLoading())
        }
    }

    const handleClose = () => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            modal: false,
        }))
        removeModalRef.current.close()
        setTimeout(() => {
            form.reset()
            form.querySelectorAll('select').forEach(i => i.value = 0)

            removeValidations()
            setCreateEdit(createEdit => ({
                ...createEdit,
                overlay: false,
                mainLoading: true,
                id: null,
                worker: worker,
                original: worker,
                icon: ''
            }))
        }, 100)
    }

    const handleSubmit = e => {
        e.preventDefault()
        let data = new FormData(e.target)

        removeValidations()

        startLoading()

        data.append('id', createEdit.id)
        data.append('icon', createEdit.icon)

        let url
        if (createEdit.id) url = 'types/update'
        else url = 'types/add'

        Api.post(url, data)
            .then(() => {
                successModalRef.current.open()
                props.handleRefreshData()
            })
            .catch(err => {
                const fields = err.response.data.errors

                Object.entries(fields).map(i => {
                    if (i[0]) {
                        let inputs = form.querySelectorAll("[name='" + i[0] + "']")

                        inputs.forEach(i => i.classList.add('validate'))
                    }
                })
            })
            .finally(() => stopLoading())
    }

    const startLoading = () => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            loading: true,
        }))
    }
    const stopLoading = () => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            loading: false,
        }))
    }

    const stopMainLoading = () => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            mainLoading: false,
        }))
    }

    const handleDelete = e => {
        e.preventDefault()
        removeModalRef.current.open()
    }
    const handleRemoveCallback = () => {
        startLoading()
        handleClose()
        Api.post('types/delete', {
            id: createEdit.id
        })
            .then(() => {
                stopLoading()
                props.handleRefreshData()
            })
    }

    const handleOpenUpload = e => {
        e.preventDefault()

        const input = uploadInputRef.current

        input.click()
    }

    const handleAttachFiles = e => {
        const attachment = e.target.files[0]

        setCreateEdit(createEdit => ({
            ...createEdit,
            icon: attachment
        }))
    }

    const calcFileSize = size => {
        return (size / 1000).toFixed(0)
    }

    const handleDetachFile = () => {
        setCreateEdit(createEdit => ({
            ...createEdit,
            icon: '',
            original: {
                ...createEdit,
                image: '',
            }
        }))
    }

    const removeValidations = () => form.querySelectorAll('.validate').forEach(i => i.classList.remove('validate'))

    return (
        <div className={`${createEdit.overlay ? 'visible' : ''} overlay`}>
            <RemoveModal
                mainMessage="Сигурни ли сте, че искате да изтриете този проект?"
                secondaryMessage="Prespa Invest не съхранява изтритите от Вас данни."
                ref={removeModalRef}
                handleRemoveCallback={handleRemoveCallback}
                loading={createEdit.loading}
            />
            <SuccessModal
                mainMessage={createEdit.id ? 'Успешно редактирахте проект!' : 'Проекта е добавен успешно!'}
                secondaryMessage="Може да откриете промените в списъка с проекти."
                ref={successModalRef}
                handleSuccessAction={handleClose}
            />
            <div className="scroller">
                <div className={`${createEdit.modal ? 'show' : ''} box box-small`}>
                    <img src={closeIcon} className="close" onClick={handleClose} />
                    <form id="edit-form" onSubmit={handleSubmit} className="create-task">
                        <h3>
                            {createEdit.id ?
                                'Редакция на проект' :
                                'Добавяне на проект'
                            }
                        </h3>
                        {createEdit.mainLoading ?
                            <img src={loader} alt="loading" />
                            :
                            <>
                                <div className="row">
                                    <div className="col full-width">
                                        <label>
                                            Проект
                                    </label>
                                        <input
                                            type="text"
                                            name="name"
                                            defaultValue={createEdit.worker.name}
                                        />
                                    </div>
                                </div>
                                {(createEdit.icon || createEdit.original.image) && <div
                                    className="attachments scroller-list"
                                    style={{ width: '100%' }}
                                >
                                    <div className="attachment selected-list">
                                        <img
                                            src={createEdit.icon ? URL.createObjectURL(createEdit.icon) : createEdit.original.image}
                                            alt={createEdit.icon ? createEdit.icon.name : createEdit.original.name}
                                            title={createEdit.icon ? createEdit.icon.name : createEdit.original.name}
                                            className="main-icon"
                                        />
                                        <div
                                            className="name"
                                            style={{ maxWidth: '165px' }}
                                        >
                                            {createEdit.icon ? createEdit.icon.name : createEdit.original.name}
                                        </div>
                                        <div className="size">
                                            {createEdit.icon ? `${calcFileSize(createEdit.icon.size)} KB` : ''}
                                        </div>
                                        <img
                                            src={deleteIcon}
                                            alt="Изтриване"
                                            onClick={handleDetachFile}
                                        />
                                    </div>
                                </div>}
                                <div
                                    className="attach-image"
                                    name="icon"
                                    style={{ width: '100%' }}
                                >
                                    <input
                                        ref={uploadInputRef}
                                        type="file"
                                        accept="image/*"
                                        onChange={handleAttachFiles}
                                        multiple
                                        hidden
                                    />
                                    <button
                                        className="btn-extra-add"
                                        onClick={handleOpenUpload}
                                        style={{ backgroundPosition: '10px center' }}
                                    >
                                        Добавяне на икона
                                </button>
                                </div>

                                <div className="buttons">
                                    {createEdit.loading ?
                                        <img src={loader} alt="loading" />
                                        :
                                        <>
                                            {createEdit.id && <button className="btn-delete" onClick={handleDelete}>
                                                Изтриване
                                        </button>}
                                            <button className="btn-add">
                                                {createEdit.id ?
                                                    'Запазване' :
                                                    'Добавяне'
                                                }
                                            </button>
                                        </>
                                    }
                                </div>
                            </>
                        }
                    </form>
                </div>
            </div>
        </div>
    )
}

export default forwardRef(CreateEdit)